<template>
  <div class="list">
    <div>
      <!-- <Bread :fromName="fromName" :menuName="menuName"></Bread> -->
      <!-- <Artice v-if="showList"></Artice> -->
      <div class="search-container" v-if="isShowSearch">
        <div class="screen">
          <div class="screen-item screen-type">
            <div class="screen-item-name">Data Type:</div>
            <div class="screen-item-value" id="cd1">
              <span data-cid="0" class="ac">All</span>

              <span data-cid="1" class="">Observation data</span>

              <span data-cid="2" class="">Data Products</span>
            </div>
          </div>
          <div class="screen-item screen-area">
            <div class="screen-item-name">Area:</div>
            <div class="screen-item-value Observation" id="cd2">
              <span data-cid="0" class="ac">All</span>

              <span data-cid="7" class="">Global</span>

              <span data-cid="3" class="">Indonesian Sea </span>

              <span data-cid="4" class="">Western Pacific </span>

              <span data-cid="5" class="">Indian Ocean </span>

              <span data-cid="6" class="">China adjacent Seas</span>
            </div>
          </div>
          <div class="screen-item screen-search">
            <div class="screen-item-name">Keyword:</div>
            <div class="screen-item-value">
              <div class="search">
                <input
                  type="text"
                  id="key"
                  placeholder="Please enter query keywords"
                />
                <div>
                  <img
                    src="../../assets/images/search.png"
                    id="btnsch"
                    alt="搜索"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="list-detail-container">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <div class="item-year" v-if="item.vice_title">
            {{ item.vice_title }}
          </div>
          <div class="item-img">
            <img :src="`${filePreview}${item.cover}`" alt="" />
          </div>
          <div class="item-content" @click="toMore(item)">
            <div class="item-title">
              {{ item.title }}
            </div>
            <div class="item-article" v-html="item.digest">
              <!-- {{ item.digest }} -->
            </div>
            <div class="item-readMore">
              Read More
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
        <div class="pagination" v-if="showPage">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :current-page="query.pageNo"
            :page-size="query.pageSize"
            :total="query.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Artice from './Artice.vue';
import Bread from './Bread.vue';
export default {
  components: {
    Bread,
    Artice
  },
  name: 'List',
  props: {
    menuName: {
      type: String,
      default: '',
      required: false
    },
    fromName: {
      type: String,
      default: '',
      required: false
    },
    pid: {
      type: String,
      default: '',
      required: false
    }
  },
  watch: {
    // 监听路由发生改变
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        this.ucode = val.query.code || val.query.ucode;
        this.getInfo(this.ucode);
        // if(newVal.query.q) this.requestData()
      }
    },
    pid: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('list_pid', val);
      }
    }
  },
  created() {
    // this.getInfo()
    let pid = localStorage.getItem('pro__pid');
    console.log(`listPid`, pid);
  },
  data() {
    return {
      ucode: '',
      list: [],
      filePreview: `${window._CONFIG['filePreview']}?fileId=`,
      showList: false,
      showPage: false,
      query: {
        pageNo: 1,
        pageSize: 3,
        total: ''
      }
    };
  },
  computed: {
    isShowSearch() {
      return this.ucode === '36261a89badc4e0dbac011fcd18a6864?use_type=23';
    }
  },
  methods: {
    getInfo() {
      // let ucode = '36261a89badc4e0dbac011fcd18a6864'
      let params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        is_publish: 1,
        column: 'id',
        order: 'order',
        superQueryMatchType: 'and'
      };
      let url = `${window._CONFIG['domianURL']}xmu/index/getData/${this.ucode}`;
      this.$axios({
        method: 'get',
        url: url,
        params: params
      }).then(res => {
        let data = res.data.result.records;
        this.query.total = res.data.result.total;
        this.list = data;
        this.list.forEach(e => {
          e.api = '36261a89badc4e0dbac011fcd18a6864/' + e.id;
        });
        let page = data[0].is_pagination;
        if (page == 1) {
          this.showPage = true;
        } else {
          this.showPage = false;
        }
      });
    },
    toMore(item) {
      if (this.isShowSearch) {
        window.open(item.source, '_blank');
        return;
      }
      this.$router.push({
        path: '/content',
        query: {
          title: this.$route.query.title,
          name: this.$route.query.name,
          ucode: this.$route.query.code,
          id: item.id
        }
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.query.pageNo = val;
      this.getInfo();
    }
  }
};
</script>

<style lang="less" scoped>
header {
  background-color: rgb(0 0 0 / 10%);
}
.list {
  position: relative;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
.list-header {
  width: 100%;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.list-item {
  margin-bottom: 30px;
  position: relative;
  // height: 220px;
  background-color: #f8f9fb;
  display: flex;
  flex-direction: row;
  padding: 20px;
}
.list-detail-container {
  padding: 0px 230px 15px 220px;
}

.item-year {
  background-color: #032f6d;
  font-family: FZZongYi-M05S;
  font-weight: 400;
  color: #ffffff;
  width: 110px;
  height: 28px;
  position: absolute;
  right: 18px;
  top: -15px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.item-img {
  margin-right: 30px;
  width: 450px;
  height: 280px;
  img {
    object-fit: contain;
    height: 280px;
    width: 100%;
  }
}
.item-content {
  width: 80%;
}
.item-title {
  cursor: pointer;
  font-size: 20px;
  font-family: 'Adobe Heiti Std';
  font-weight: bold;
  color: #000000;
  line-height: 30px;
}
.item-article {
  cursor: pointer;
  line-height: 24px;
  margin-top: 7px;
  margin-bottom: 10px;
  font-size: 16px;
  font-family: Arial;
  font-weight: 400;
  color: #5c5c5c;
  white-space: pre-wrap;
}
.item-readMore {
  cursor: pointer;
  position: absolute;
  right: 40px;
  font-size: 16px;
  bottom: 10px;
  font-family: FZZongYi-M05S;
  font-weight: 400;
  color: #032f6d;
}
.pagination {
  display: flex;
  justify-content: center;
}
/deep/.el-menu {
  background-color: unset;
}
// 修改分页选中时背景色
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00519b;
}

/deep/ .search-container {
  margin: 30px 0px;
  padding: 0px 230px 15px 220px;
  .screen {
    border: 1px solid #dcdcdc;
    border-radius: 5px;
    .screen-item {
      height: 55px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dcdcdc;
      .screen-item-name {
        height: 100%;
        line-height: 55px;
        width: 146px;
        text-align: right;
        background: #f2f2f2;
        border-right: 1px solid #dcdcdc;
        font-size: 18px;
        font-family: 'Microsoft YaHei';
        color: rgb(10, 51, 123);
        font-weight: bold;
        padding: 0 20px;
        box-sizing: border-box;
        flex-shrink: 0;
      }
      .screen-item-value {
        font-size: 16px;
        font-family: 'Arial';
        color: #0a337b;
        height: 100%;
        flex-grow: 1;
        background: #faf9f9;
        display: inline-block;
        padding: 0 45px;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: nowrap;
        span {
          margin-left: 20px;
          line-height: 55px;
          display: inline-block;
          cursor: pointer;
          &:first-child {
            margin-left: 0;
          }
        }
        .ac {
          color: rgb(34, 180, 255);
          position: relative;
          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 10px;
            width: 100%;
            height: 3px;
            background: rgb(34, 180, 255);
          }
        }
      }
      .search {
        border: 1px solid #dcdcdc;
        border-radius: 5px;
        overflow: hidden;
        width: 50%;
        height: 41px;
        margin-top: 7px;
        display: flex;
        align-items: center;
        input {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          padding: 0 5px;
          box-sizing: border-box;
        }
        div {
          width: 41px;
          height: 41px;
          background: #f2f2f2;
          flex-shrink: 1;
          display: block;
          text-align: center;
          cursor: pointer;
          img {
            width: 22px;
            height: 22px;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
